<div class="sticky-header-outer-wrapper" [class.scrolled]="isHeaderScrolled">
  <div class="header">
    <div class="header-left">
      <h1>Confirm Enquiry</h1>
      <p>Please review your items below before sending the enquiry.</p>
    </div>
    <div class="top-actions">
      <button class="cancel-btn" (click)="cancel()">
        Cancel
      </button>
      <button class="confirm-btn" (click)="onConfirm()" [disabled]="cartItems.length === 0">
        Confirm All
      </button>
    </div>
  </div>
</div>

<div class="confirm-container">
  <div class="content">
    <!-- USER DETAILS SECTION -->
    <div class="card user-details">
      <div class="details-header">
        <h2>Contact Details</h2>
        <button class="icon-btn" (click)="enableEdit()" *ngIf="!isEditing">
          <mat-icon>edit</mat-icon>
        </button>
        <button class="save-link" (click)="saveData()" *ngIf="isEditing">
          Save
        </button>
      </div>

      <div class="details-grid">
        <div class="row">
          <span>Name:</span>
          <strong *ngIf="!isEditing">{{ userDetails.name }}</strong>
          <input *ngIf="isEditing" type="text" [(ngModel)]="userDetails.name" placeholder="Name" />
        </div>
        <div class="row">
          <span>Phone:</span>
          <strong *ngIf="!isEditing">{{ userDetails.phone }}</strong>
          <input *ngIf="isEditing" type="text" [(ngModel)]="userDetails.phone" placeholder="Phone" />
        </div>
        <div class="row">
          <span>Company Name:</span>
          <strong *ngIf="!isEditing">{{
            userDetails.companyName || "-"
            }}</strong>
          <input *ngIf="isEditing" type="text" [(ngModel)]="userDetails.companyName" placeholder="Company Name" />
        </div>
        <div class="row">
          <span>Company Address:</span>
          <strong *ngIf="!isEditing">{{
            userDetails.companyAddress || "-"
            }}</strong>
          <textarea *ngIf="isEditing" [(ngModel)]="userDetails.companyAddress" placeholder="Address"
            rows="2"></textarea>
        </div>
        <div class="row">
          <span>Email:</span>
          <strong *ngIf="!isEditing">{{ userDetails.email }}</strong>
          <input *ngIf="isEditing" type="email" [(ngModel)]="userDetails.email" placeholder="Email" />
        </div>

        <!-- Business License Fields -->
        <div class="row">
          <span>License No:</span>
          <strong *ngIf="!isEditing">{{
            userDetails.businessLicenseNo || "-"
            }}</strong>
          <input *ngIf="isEditing" type="text" [(ngModel)]="userDetails.businessLicenseNo" placeholder="License No" />
        </div>
        <div class="row">
          <span>Valid Till:</span>
          <strong *ngIf="!isEditing">{{
            userDetails.licenseValidTill | date: "dd/MM/yyyy"
            }}</strong>
          <!-- Simplified date input for editing in this view, strictly could be a datepicker but text is okay for quick fix if format matches -->
          <input *ngIf="isEditing" type="date" [ngModel]="userDetails.licenseValidTill | date: 'yyyy-MM-dd'"
            (ngModelChange)="
                userDetails.licenseValidTill = $event ? $event : null
              " />
        </div>
        <div class="row">
          <span>Issued By:</span>
          <strong *ngIf="!isEditing">{{
            userDetails.licenseIssuedBy || "-"
            }}</strong>
          <input *ngIf="isEditing" type="text" [(ngModel)]="userDetails.licenseIssuedBy" placeholder="Issued By" />
        </div>
      </div>
    </div>

    <!-- CART ITEMS LIST -->
    <div class="card items-list">
      <h2>Booking Items</h2>

      <div class="item-row" *ngFor="let item of cartItems">
        <div class="item-img">
          <img [src]="
                item.equipmentData?.images?.[0] || 'assets/default-equipment.jpg'
              " alt="" />
        </div>
        <div class="item-info">
          <h3>{{ item.equipmentData?.listingName || item.equipmentData?.name }}</h3>
          <p>
            {{ item.equipmentData?.brand }}
            <span *ngIf="item.equipmentData?.emirate">
              • {{ item.equipmentData?.emirate }}</span>
          </p>
          <div class="dates">
            {{ item.startDate | date: "dd MMM yyyy" }} -
            {{ item.endDate | date: "dd MMM yyyy" }}
          </div>
        </div>
        <div class="item-price">
          AED {{ item.totalAmount | number: "1.2-2" }}
        </div>
      </div>
    </div>

    <!-- TOTALS -->
    <div class="card summary">
      <div class="row">
        <span class="label">Subtotal</span>
        <span class="value">AED {{ grandTotal | number: "1.2-2" }}</span>
      </div>
      <hr />
      <div class="row total">
        <span class="label">Grand Total</span>
        <span class="value">AED {{ finalAmount | number: "1.2-2" }}</span>
      </div>
    </div>
  </div>

</div>